<div class="row">
  <div class="col-12">
    <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
      <i class="fa fa-plus"></i> Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy table-sm">
  <thead>
    <tr>
      <th class="text-center" colspan="3">Medição / Empenho</th>
      <th class="text-center" colspan="3">Documento Fiscal</th>
      <th class="text-center" colspan="3">Pagamento</th>
      <th></th>
    </tr>
    <tr>
      <th scope="col" style="width: 100px">Medição</th>
      <th scope="col" style="width: 100px">Empenho</th>
      <th scope="col" style="width: 100px">Data</th>
      <th scope="col" style="width: 100px">Documento Fiscal</th>
      <th scope="col" style="width: 100px">Data</th>
      <th scope="col" style="width: 100px">Estado</th>
      <th scope="col" style="width: 100px">Valor</th>
      <th scope="col" style="width: 100px">Data</th>
      <th scope="col" style="width: 100px">Encargos</th>
      <th scope="col" style="width: 100px"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of entidade?.Pagto">
      <td *ngIf="!item.editavel">
        <span>{{item.MedicaoNumero}}</span>
      </td>
      <td *ngIf="!item.editavel">
        <span>{{item.NotaEmpenhoNumero}}</span>
      </td>
      <td *ngIf="!item.editavel">
        <span>{{item.NotaEmpenhoDataEmissao}}</span>
      </td>
      <td *ngIf="!item.editavel">
        <span>{{item.DocumentoFiscalNumero}}</span>
      </td>
      <td *ngIf="!item.editavel">
        <span>{{item.DocumentoFiscalDataEmissao}}</span>
      </td>
      <td *ngIf="!item.editavel">
        <span>{{item.DocumentoFiscalUF}}</span>
      </td>

      <td *ngIf="item.editavel" colspan="6">
        <select *ngIf="item.editavel" class="form-control" [(ngModel)]="item.liquidacaoId"
          [ngModelOptions]="{standalone: true}" (change)="atribuirDocFiscal(item.liquidacaoId)">
          <option *ngFor="let item of listaDocFiscal" [ngValue]="item.liquidacaoId">
            Medição: {{item.MedicaoNumero}} |
            Empenho: {{item.NotaEmpenhoNumero}} |
            Doc. Fiscal: {{item.DocumentoFiscalNumero}}
          </option>
        </select>
      </td>

      <td *ngIf="!item.editavel">
        <span>{{item.NotaFiscalValorPago | number: '1.2-2'}}</span>
      </td>

      <td *ngIf="!item.editavel">
        <span>{{item.NotaFiscalPagtoDt}}</span>
      </td>

      <td *ngIf="item.editavel" colspan="2">
        <select *ngIf="item.editavel" class="form-control" [(ngModel)]="item.pagamentoId"
          [ngModelOptions]="{standalone: true}" (change)="atribuirPagamento(item.pagamentoId)">
          <option *ngFor="let item of listaPagamento" [ngValue]="item.pagamentoId">
            {{item.data_pagamento | date:'dd/MM/yyyy':'GMT'}} | {{item.valor_pago | number: '1.2-2'}}
          </option>
        </select>
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.RecolhidoEncargosPrevidenciario}}</span>
        <p-selectButton *ngIf="item.editavel" [options]="opcoesSimNao" optionValue="id"
          [(ngModel)]="item.RecolhidoEncargosPrevidenciario" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </td>

      <td class="text-right">
        <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>